import watermindsLogo from "../../../assets/waterminds-logo.png";
import GenericForm from "common/Components/GenericForm/GenericForm";
import {
  StyledPage,
  StyledAuthMain,
  StyledResetContainer,
  StyledCard,
  StyledAuthCardHeader,
  StyledWatermindsLogo,
  StyledTitle,
  StyledSubtitle,
  StyledAuthForm,
  StyledAuthFormFields,
  StyledAuthBackLinkWrap,
  StyledAuthSuccessBand,
  StyledAuthSuccessMark,
  StyledAuthSuccessBandText,
  StyledAuthSuccessBody,
  StyledAuthSrOnly,
  StyledErrorMessage,
  StyledSignupSubmitButton,
  StyledAuthTextLink,
} from "../AuthPageLayout.styles";
import { RESET_PASSWORD_UI } from "./confirmResetPassword.constants";
import { useConfirmResetPassword } from "./ConfirmResetPassword.hook";

function ResetPasswordStatusCard({ title, subtitle, children }) {
  return (
    <StyledPage>
      <StyledAuthMain>
        <StyledResetContainer>
          <StyledCard>
            <StyledAuthCardHeader>
              <StyledWatermindsLogo src={watermindsLogo} alt="Waterminds Logo" />
              {title ? (
                <StyledTitle variant="h5" component="h2">
                  {title}
                </StyledTitle>
              ) : null}
              {subtitle ? (
                <StyledSubtitle component="p">{subtitle}</StyledSubtitle>
              ) : null}
            </StyledAuthCardHeader>
            {children}
          </StyledCard>
        </StyledResetContainer>
      </StyledAuthMain>
    </StyledPage>
  );
}

export default function ConfirmResetPassword() {
  const {
    username,
    formValues,
    errors,
    bannerError,
    success,
    loading,
    resetFields,
    handleChange,
    handleBack,
    handleGoToSignIn,
    handleBackToApp,
    submit,
    navigate,
  } = useConfirmResetPassword();

  if (!username) {
    return (
      <ResetPasswordStatusCard
        title={RESET_PASSWORD_UI.missingSessionTitle}
        subtitle={RESET_PASSWORD_UI.missingSessionMessage}
      >
        <StyledAuthBackLinkWrap>
          <StyledAuthTextLink
            type="button"
            variant="text"
            onClick={handleBackToApp}
            fullWidth
          >
            {RESET_PASSWORD_UI.backToAppLabel}
          </StyledAuthTextLink>
        </StyledAuthBackLinkWrap>
      </ResetPasswordStatusCard>
    );
  }

  if (success) {
    return (
      <ResetPasswordStatusCard
        title={RESET_PASSWORD_UI.title}
        subtitle={RESET_PASSWORD_UI.subtitle}
      >
        <StyledAuthSuccessBand role="status">
          <StyledAuthSuccessMark aria-hidden="true">✓</StyledAuthSuccessMark>
          <StyledAuthSuccessBandText component="span">
            <StyledAuthSrOnly>Success: </StyledAuthSrOnly>
            {RESET_PASSWORD_UI.successBannerTitle}
          </StyledAuthSuccessBandText>
        </StyledAuthSuccessBand>
        <StyledAuthSuccessBody component="p">
          {RESET_PASSWORD_UI.successMessage}
        </StyledAuthSuccessBody>
        <StyledSignupSubmitButton
          type="button"
          variant="contained"
          onClick={handleGoToSignIn}
        >
          {RESET_PASSWORD_UI.successCtaLabel}
        </StyledSignupSubmitButton>
        <StyledAuthBackLinkWrap>
          <StyledAuthTextLink
            type="button"
            variant="text"
            onClick={handleBackToApp}
            fullWidth
          >
            {RESET_PASSWORD_UI.backToAppLabel}
          </StyledAuthTextLink>
        </StyledAuthBackLinkWrap>
      </ResetPasswordStatusCard>
    );
  }

  return (
    <ResetPasswordStatusCard
      title={RESET_PASSWORD_UI.title}
      subtitle={RESET_PASSWORD_UI.subtitle}
    >
      <StyledAuthForm noValidate onSubmit={submit}>
        <StyledAuthFormFields>
          <GenericForm
            fields={resetFields}
            values={formValues}
            onChange={handleChange}
            errors={errors}
            showBorder={false}
          />
        </StyledAuthFormFields>
        {bannerError ? (
          <StyledErrorMessage component="p">{bannerError}</StyledErrorMessage>
        ) : null}
        <StyledSignupSubmitButton
          type="submit"
          variant="contained"
          disabled={loading}
        >
          {loading
            ? RESET_PASSWORD_UI.submittingLabel
            : RESET_PASSWORD_UI.submitLabel}
        </StyledSignupSubmitButton>
      </StyledAuthForm>
      <StyledAuthBackLinkWrap>
        <StyledAuthTextLink
          type="button"
          variant="text"
          onClick={handleBack}
          disabled={loading}
          fullWidth
        >
          {RESET_PASSWORD_UI.backToAppLabel}
        </StyledAuthTextLink>
      </StyledAuthBackLinkWrap>
    </ResetPasswordStatusCard>
  );
}
